import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withTranslation } from 'react-i18next';
import { supportContext } from '../../mylib/FormulaSupport';

import '../../../css/formula-support.scss';

const unreadRevision = (items) =>
  items
    .map((item) => {
      const unreadIds = item.messages
        .filter((message) => message.sender === 'LAB' && !message.seen_at)
        .map((message) => message.formulasupportmessageid)
        .sort((left, right) => left - right);
      return `${item.supportcaseid}:${unreadIds.join(',')}`;
    })
    .join(';');

const latestMessage = (item) =>
  item.messages?.length
    ? supportContext(item).context
    : item.latest_message || {};

class FormulaSupportNotification extends Component {
  state = {
    dismissed: false,
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.enabled && this.props.enabled) {
      this.props.fetchFormulaSupportNotifications();
    }

    if (
      this.state.dismissed &&
      unreadRevision(prevProps.items) !== unreadRevision(this.props.items)
    ) {
      this.setState({ dismissed: false });
    }
  }

  componentDidMount() {
    if (this.props.enabled) {
      this.props.fetchFormulaSupportNotifications();
    }
  }

  dismiss = () => {
    this.setState({ dismissed: true });
  };

  render() {
    const { enabled, items, navigateTo, t } = this.props;

    if (!enabled || items.length === 0 || this.state.dismissed) {
      return null;
    }

    return (
      <div
        className="formula-support-notification"
        role="status"
        aria-live="polite"
        data-testid="formula-support-notification"
      >
        <button
          type="button"
          className="formula-support-notification-close"
          aria-label={t('fn.close', 'Close')}
          onClick={this.dismiss}
        >
          ×
        </button>
        <div className="formula-support-notification-items">
          {items.map((item) => {
            const message = latestMessage(item);
            const color = message.colourcode || message.colourname || '';
            const product = message.productname || '';

            return (
              <button
                type="button"
                className="formula-support-notification-item"
                key={item.supportcaseid}
                aria-label={`#${item.supportcaseid}: ${color} ${product}`}
                data-testid={`formula-support-notification-${item.supportcaseid}`}
                onClick={() =>
                  navigateTo(`/order-queue?supportCase=${item.supportcaseid}`)
                }
              >
                <span className="formula-support-notification-icon">
                  <FontAwesomeIcon icon="envelope" />
                </span>
                <span className="formula-support-notification-text">
                  <strong>{color || `#${item.supportcaseid}`}</strong>
                  {product && (
                    <span className="formula-support-notification-product">
                      {product}
                    </span>
                  )}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    );
  }
}

FormulaSupportNotification.propTypes = {
  enabled: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  navigateTo: PropTypes.func.isRequired,
  fetchFormulaSupportNotifications: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export { FormulaSupportNotification };

export default withTranslation('translations')(FormulaSupportNotification);
